import React, { useState, useEffect } from 'react';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import IntroContainer from '../IntroContainer/IntroContainer';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';

export default function PreJoinScreens() {
  const { getAudioAndVideoTracks } = useVideoContext();

  const [name, setName] = useState<string>('');
  const [roomName, setRoomName] = useState<string>('');

  const [mediaError, setMediaError] = useState<Error>();

  useEffect(() => {
    setName(new URLSearchParams(window.location.search).get('name') ?? '');
    setRoomName(new URLSearchParams(window.location.search).get('room') ?? '');
    localStorage.setItem('portal_token', new URLSearchParams(window.location.search).get('token') ?? '');

    window.history.pushState({}, document.title, window.location.pathname);
  }, []);

  useEffect(() => {
    if (!mediaError) {
      getAudioAndVideoTracks().catch(error => {
        console.log('Error acquiring local media:');
        console.dir(error);
        setMediaError(error);
      });
    }
  }, [getAudioAndVideoTracks, mediaError]);

  return (
    <IntroContainer>
      <MediaErrorSnackbar error={mediaError} />
      <DeviceSelectionScreen name={name} roomName={roomName} />
    </IntroContainer>
  );
}
